import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      height: calc(-100px + 100vh);
    }
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    max-width: auto;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  h3 {
    color: #142c1f;
    font-size: 16px;
  }
  .app-instruction {
    margin: 12px 0 24px;
    color: #444444;
    line-height: 1.5;
    opacity: 0.7;
  }
`;

export const Title = styled.h3`
  color: #142c1f;
  margin: 12px auto;
  font-size: 16px;
  text-align: center;
  @media screen and (max-width: 768px) {
    width: 280px;
    line-height: 24px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e2e4e9;
`;

export const EmailConfirmBox = styled.div`
  background-color: #f9fdfb;
  border: 2px solid #2ecf96cc;
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;

  p {
    color: #818d88;
    line-height: 1.5;
    margin-bottom: 8px;
  }
`;

export const AppStoreLinks = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 12px;
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .store-link {
    img {
      width: 100%;
      height: 50px;
      border-radius: 8px;
    }
    @media screen and (min-width: 768px) {
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        height: 50px;
      }
    }
  }
`;

export const SupportInfo = styled.div`
  margin-top: 24px;
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid #e2e4e9;

  p {
    color: #44554c;
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: 8px;
  }

  a {
    color: #1c9d87;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
